import EditorLinkModal from './EditorLinkModal';
import EditorImgModal from './EditorImgModal';
import EditorVideoModal from './EditorVideoModal';
import EditorAudioModal from './EditorAudioModal';
import EditorFormulaModal from './EditorFormulaModal';

export {
  EditorLinkModal,
  EditorImgModal,
  EditorVideoModal,
  EditorAudioModal,
  EditorFormulaModal,
};

export default {};



// WEBPACK FOOTER //
// ./src/components/EditorModal/index.js